import React, { Component, Fragment } from "react";
import Time from "react-time-format";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import {
  change_Lang,
  EveryTimeTo_English,
} from "../../../actions/Helper_action";
import { Creating_Take_Money } from "../../../actions_agent/Invoice_action";
import { Tabs, TabList, Tab } from "react-tabs";
import Breadcrumb from "../../../components/common/breadcrumb";
import { Input, Select } from "antd";
import Swal from "sweetalert2";
import PropertyesList from "../../Propertys_Agent/PropertyesList";
import setToken from "../../../util/SetToken";
import Instance from "../../../util/Instance";
import { FaPrint, FaRegFile, FaRegSave } from "react-icons/fa";
export class TakeMoney extends Component {
  constructor(props) {
    super(props);
    var curr = new Date();
    curr.setDate(curr.getDate());
    let today = curr.toISOString().substr(0, 10);
    this.state = {
      Amount: 0,
      currency: "dolar",
      Money_provider: "",
      Money_recive: "",
      from: today,
      to: today,
      type:
        this.props.lang === "en"
          ? "Monthly rent invoice"
          : this.props.lang === "krd"
          ? "کرێی مانگانە"
          : "فواتير الإيجار الشهري",
      instead_of: "",
      R_cursor: 0,
      List_names: [],
      tid: "",
      pedraw: "",
      balanceRemian: 0,
      property: "",
      place: "",
      num: "",
      note: "",
      is_validate: false,
      box_status: "on",
      //suggestion
      R_cursor: 0,
      List_names: [],
      redirect_print: false,
    };
  }
  componentDidUpdate(prevProps) {
    const { sell_invoice_obj, rent_invoice_obj } = this.props;
    if (rent_invoice_obj !== "") {
      if (prevProps.rent_invoice_obj !== rent_invoice_obj) {
        this.setState({
          Amount:
            rent_invoice_obj.introduction !== undefined
              ? parseFloat(
                  rent_invoice_obj.introduction.toString().replace(/,/g, "")
                )
              : 0,
          Money_provider:
            rent_invoice_obj.tenantId.secondname !== ""
              ? rent_invoice_obj.tenantId.secondname
              : "",
          Money_recive:
            rent_invoice_obj.firstname !== "" ? rent_invoice_obj.firstname : "",
          property:
            rent_invoice_obj.available_id.Property !== ""
              ? rent_invoice_obj.available_id.Property
              : "",
          num:
            rent_invoice_obj.available_id.NOoFProperty !== ""
              ? rent_invoice_obj.available_id.NOoFProperty
              : "",
          place:
            rent_invoice_obj.available_id.Place_ku !== ""
              ? rent_invoice_obj.available_id.Place_ku
              : "",
          currency:
            rent_invoice_obj.currency !== "" ? rent_invoice_obj.currency : "",
        });
      } else if (sell_invoice_obj !== "") {
        if (prevProps.sell_invoice_obj !== sell_invoice_obj) {
          this.setState({
            Amount:
              sell_invoice_obj.introduction !== undefined
                ? parseFloat(
                    sell_invoice_obj.introduction.toString().replace(/,/g, "")
                  )
                : 0,
            Money_provider:
              sell_invoice_obj.secondname !== ""
                ? sell_invoice_obj.secondname
                : "",
            Money_recive:
              sell_invoice_obj.firstname !== ""
                ? sell_invoice_obj.firstname
                : "",
            property:
              sell_invoice_obj.available_id.Property !== ""
                ? sell_invoice_obj.available_id.Property
                : "",
            num:
              sell_invoice_obj.available_id.NOoFProperty !== ""
                ? sell_invoice_obj.available_id.NOoFProperty
                : "",
            place:
              sell_invoice_obj.available_id.Place_ku !== ""
                ? sell_invoice_obj.available_id.Place_ku
                : "",
            currency:
              sell_invoice_obj.s_currency !== ""
                ? sell_invoice_obj.s_currency
                : "",
          });
        }
      }
    }
  }
  Search_Suggesstion = async () => {
    if (localStorage.token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const { Money_provider } = this.state;
      const res = await Instance.get(
        `/api/v1/SearchNameRentContract?name=${Money_provider}`,
        config
      );
      this.setState({
        List_names: res.data.data,
      });
    } catch (error) {}
  };
  Search_Name_Handle = (e) => {
    this.setState(
      {
        Money_provider: e.target.value,
      },
      () => {
        this.Search_Suggesstion();
      }
    );
  };
  R_hanldeKeyup = (e) => {
    if (e.keyCode === 27) {
      this.setState({ List_names: [] });
      return false;
    }
  };
  R_hanldeKeydown = (e) => {
    const { R_cursor, List_names } = this.state;
    if (e.keyCode === 38 && R_cursor > 0) {
      this.setState((prevState) => ({
        R_cursor: prevState.R_cursor - 1,
      }));
    } else if (e.keyCode === 40 && R_cursor < List_names.length - 1) {
      this.setState((prevState) => ({
        R_cursor: prevState.R_cursor + 1,
      }));
    }
    if (e.keyCode === 46) {
      this.setState(() => {
        return {
          List_names: [],
        };
      });
    }
  };
  handleChange_Property = (value) => {
    this.setState({ property: value });
  };
  handleChange_Currency = (value) => {
    this.setState({ currency: value });
  };
  handleChange_Box = (value) => {
    this.setState({ box_status: value });
  };
  onselect = (index) => {
    if (index === 0) {
      let type =
        this.props.lang === "en"
          ? "Monthly rent invoice"
          : this.props.lang === "krd"
          ? "کرێی مانگانە"
          : "فواتير الإيجار الشهري";
      this.setState({
        type: type,
      });
    } else if (index === 1) {
      let type =
        this.props.lang === "en"
          ? "Service Bill"
          : this.props.lang === "krd"
          ? "خزمەتگوزاری"
          : "فواتير الخدمات";
      this.setState({
        type: type,
      });
    } else if (index === 2) {
      let type =
        this.props.lang === "en"
          ? "Insurance Bill"
          : this.props.lang === "krd"
          ? "دڵنیایی"
          : "التأمين";
      this.setState({
        type: type,
      });
    } else if (index === 3) {
      let type =
        this.props.lang === "en"
          ? "Sell"
          : this.props.lang === "krd"
          ? "فرۆشتن"
          : "بيع";
      this.setState({
        type: type,
      });
    } else if (index === 4) {
      let type =
        this.props.lang === "en"
          ? "Buy"
          : this.props.lang === "krd"
          ? "کڕین"
          : "شراء";
      this.setState({
        type: type,
      });
    } else if (index === 5) {
      let type =
        this.props.lang === "en"
          ? "Arabun"
          : this.props.lang === "krd"
          ? "عربون"
          : "عربون";
      this.setState({
        type: type,
      });
    } else if (index === 6) {
      let type =
        this.props.lang === "en"
          ? "comision"
          : this.props.lang === "krd"
          ? "عمولە"
          : "عمولة";
      this.setState({
        type: type,
      });
    } else if (index === 7) {
      let type =
        this.props.lang === "en"
          ? "investor"
          : this.props.lang === "krd"
          ? "وەبەرهێنەر"
          : "مستثمر";
      this.setState({
        type: type,
      });
    }
  };
  New_Page = () => {
    this.setState({
      Amount: 0,
      currency: "dolar",
      Money_provider: "",
      Money_recive: "",
      instead_of: "",
      R_cursor: 0,
      List_names: [],
      tid: "",
      pedraw: "",
      balanceRemian: 0,
      place: "",
      property: "",
      num: "",
      is_validate: false,
      box_status: "on",
      R_cursor: 0,
      List_names: [],
      redirect_print: false,
    });
  };

  onCreating_Take_Money = () => {
    const { user } = this.props;
    var curr = new Date();
    curr.setDate(curr.getDate());
    let today = curr.toISOString().substr(0, 10);
    const { EveryTimeTo_English, Creating_Take_Money, change_Lang } =
      this.props;
    const money_payer =
      this.state.box_status !== "off"
        ? `${user.fname} ${user.lname}`
        : this.state.Money_recive;
    const data = {
      Money_provider: this.state.Money_provider,
      Money_recive: money_payer,
      balanceRemian:
        this.state.balanceRemian !== ""
          ? parseFloat(this.state.balanceRemian.toString().replace(/,/g, ""))
          : 0,
      Amount:
        this.state.Amount !== ""
          ? parseFloat(this.state.Amount.toString().replace(/,/g, ""))
          : 0,
      from: this.state.from !== "" ? this.state.from : today,
      to: this.state.to !== "" ? this.state.to : today,
      currency: EveryTimeTo_English(this.state.currency),
      type: EveryTimeTo_English(this.state.type),
      instead_of: this.state.instead_of,
      property: this.state.property,
      place: this.state.place,
      num: this.state.num,
      pedraw: this.state.pedraw,
      note: this.state.note,
      box_status: this.state.box_status,
    };
    let type_of = change_Lang("investor");
    if (
      (type_of !== this.state.type ? this.state.property === "" : "") ||
      (type_of !== this.state.type ? this.state.place === "" : "") ||
      (type_of !== this.state.type && this.state.num === "") ||
      this.state.Money_provider === "" ||
      this.state.box_status !== "on"
        ? this.state.Money_recive === ""
        : "" ||
          this.state.Amount === "" ||
          this.state.Amount === 0 ||
          this.state.type === "" ||
          this.state.currency.toString().length === 0 ||
          this.state.box_status.toString().length === 0
    ) {
      Swal.fire({
        title: "OPS",
        text: change_Lang("Please Check Inputs"),
        icon: "error",
        html: `<b class="fk">${change_Lang("Please Check Inputs")}</b>`,
        confirmButtonText: change_Lang("Ok"),
        buttonsStyling: { fontFamily: "fk" },
        timer: 1300,
      });
      this.setState({ is_validate: true });
    } else {
      Creating_Take_Money(user.branchId && user.branchId._id, data);
      Swal.fire({
        title: "Good job!",
        html: `<b class="fk">${change_Lang(
          "You successfully tainted your work"
        )}</b>`,
        icon: "success",
        confirmButtonText: change_Lang("success"),
        buttonsStyling: { fontFamily: "fk" },
        timer: 1000,
      });
      this.setState({
        is_validate: false,
        redirect_print: false,
      });
    }
  };
  onCreating_TakeMoney_Print = () => {
    const { user } = this.props;
    var curr = new Date();
    curr.setDate(curr.getDate());
    let today = curr.toISOString().substr(0, 10);
    const money_payer =
      this.state.box_status !== "off"
        ? `${user.fname} ${user.lname}`
        : this.state.Money_recive;
    const data = {
      Money_provider: this.state.Money_provider,
      Money_recive: money_payer,
      balanceRemian:
        this.state.balanceRemian !== ""
          ? parseFloat(this.state.balanceRemian.toString().replace(/,/g, ""))
          : 0,
      Amount:
        this.state.Amount !== ""
          ? parseFloat(this.state.Amount.toString().replace(/,/g, ""))
          : 0,
      from: this.state.from !== "" ? this.state.from : today,
      to: this.state.to !== "" ? this.state.to : today,
      currency: this.props.EveryTimeTo_English(this.state.currency),
      type: this.props.EveryTimeTo_English(this.state.type),
      instead_of: this.state.instead_of,
      property: this.state.property,
      place: this.state.place,
      num: this.state.num,
      pedraw: this.state.pedraw,
      redirect: true,
      note: this.state.note,
      box_status: this.state.box_status,
    };
    let type_of = this.props.change_Lang("investor");
    if (
      (type_of !== this.state.type ? this.state.property === "" : "") ||
      (type_of !== this.state.type ? this.state.place === "" : "") ||
      (type_of !== this.state.type && this.state.num === "") ||
      this.state.Money_provider === "" ||
      this.state.box_status !== "on"
        ? this.state.Money_recive === ""
        : "" ||
          this.state.Amount === "" ||
          this.state.Amount === 0 ||
          this.state.type === "" ||
          this.state.currency.toString().length === 0 ||
          this.state.box_status.toString().length === 0
    ) {
      Swal.fire({
        title: "OPS",
        text: this.props.change_Lang("Please Check Inputs"),
        icon: "error",
        html: `<b class="fk">${this.props.change_Lang(
          "Please Check Inputs"
        )}</b>`,
        confirmButtonText: this.props.change_Lang("Ok"),
        buttonsStyling: { fontFamily: "fk" },
        timer: 1300,
      });
      this.setState({ is_validate: true });
    } else {
      this.props.Creating_Take_Money(user.branchId && user.branchId._id, data);
      Swal.fire({
        title: "Good job!",
        html: `<b class="fk">${this.props.change_Lang(
          "You successfully tainted your work"
        )}</b>`,
        icon: "success",
        confirmButtonText: this.props.change_Lang("success"),
        buttonsStyling: { fontFamily: "fk" },
        timer: 1000,
      });
      this.setState({
        is_validate: false,
        redirect_print: true,
      });
    }
  };
  OnChangeHandler = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  TakeMoney_getPrint = () => {
    window.setTimeout("window.print()", 4000);
  };

  render() {
    const { change_Lang, lang, user, name_krd, name_arb, name_en } = this.props;
    const {
      OnChangeHandler,
      Search_Name_Handle,
      R_hanldeKeyup,
      R_hanldeKeydown,
      onCreating_TakeMoney_Print,
    } = this;
    const {
      Amount,
      Money_provider,
      currency,
      place,
      property,
      num,
      from,
      to,
      note,
      is_validate,
      instead_of,
      box_status,
      Money_recive,
      List_names,
      R_cursor,
      redirect_print,
    } = this.state;
    var curr = new Date();
    curr.setDate(curr.getDate());
    let today = curr.toISOString().substr(0, 10);
    const { Option } = Select;
    if (redirect_print) {
      return <Redirect to="/take_money_list" />;
    } else {
      return (
        <Fragment>
          <Breadcrumb
            title={change_Lang("Repayment bills")}
            parent={change_Lang("s_dashboard")}
          />
          <Tabs onSelect={(index) => this.onselect(index)}>
            <div
              className={`${
                lang === "en" ? "container-fluid" : "container-fluid fk"
              }`}
            >
              <div
                className="card product-page-main card-body"
                style={{ background: "#e3e9f2" }}
              >
                <div className="row">
                  <div
                    className="col-md-4 d-flex justify-content-start"
                    style={{ background: "#e3e9f2" }}
                  >
                    <label
                      style={{ fontSize: "22px", color: "#4064d7" }}
                      className="product-page-details product-right mb-2 text-uppercase font-weight-bold d-none d-lg-block"
                    >
                      {lang === "krd"
                        ? name_krd
                        : lang === "arb"
                        ? name_arb
                        : name_en}
                    </label>
                  </div>

                  <div
                    className="col-md-4 d-flex justify-content-center"
                    style={{ background: "#e3e9f2" }}
                  >
                    <label
                      style={{
                        fontWeight: "bold",
                        color: "#4064d7",
                        fontSize: "30px",
                      }}
                      className="d-flex justify-content-start product-page-details product-right mb-2 text-uppercase font-weight-bold"
                    >
                      {change_Lang("Repayment bills")}
                    </label>
                  </div>
                  <div
                    className="col-md-4 d-flex justify-content-end"
                    style={{ background: "" }}
                  >
                    <div className="product-price digits form-group row">
                      <div className="col-sm-12 d-flex justify-content-start text-right">
                        <label className="d-none d-lg-inline">
                          <Time
                            value={Date.now()}
                            format="YYYY-MM-DD"
                            style={{
                              color: "#4064d7",
                              borderRadius: "5px",
                              fontSize: "22px",
                            }}
                            className="form-control fk d-flex justify-content-satrt text-right "
                          />
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-12">
                      <TabList
                        style={{ background: "white" }}
                        className={`${
                          lang === "en"
                            ? "nav nav-tabs tab-coupon d-flex justify-content-center"
                            : "nav nav-tabs tab-coupon d-flex justify-content-center fk"
                        }`}
                      >
                        <Tab
                          value={change_Lang("Monthly rent invoice")}
                          className="nav-link"
                        >
                          {change_Lang("Monthly rent invoice")}
                        </Tab>
                        <Tab className="nav-link" onChange={OnChangeHandler}>
                          {change_Lang("Service Bill")}
                        </Tab>
                        <Tab className="nav-link" onChange={OnChangeHandler}>
                          {change_Lang("Insurance Bill")}
                        </Tab>
                        <Tab className="nav-link" onChange={OnChangeHandler}>
                          {change_Lang("Sell")}
                        </Tab>
                        <Tab className="nav-link" onChange={OnChangeHandler}>
                          {change_Lang("Buy_Required_translation")}
                        </Tab>
                        <Tab className="nav-link" onChange={OnChangeHandler}>
                          {change_Lang("Arabun")}
                        </Tab>
                        <Tab className="nav-link" onChange={OnChangeHandler}>
                          {change_Lang("comision")}
                        </Tab>
                        <Tab className="nav-link" onChange={OnChangeHandler}>
                          {change_Lang("investor")}
                        </Tab>
                      </TabList>
                    </div>
                  </div>
                  <div className="row mb-4 ">
                    <div className="col-sm-6  ">
                      <div className="product-price digits mt-2 d-flex justify-content-start form-group row">
                        <div className="col-sm-4">
                          <label
                            style={{
                              fontSize: "18px",
                              color: "#4064d7",
                              fontWeight: "bold",
                            }}
                            className="d-flex justify-content-start  col-form-label fk"
                          >
                            {change_Lang("received from Mr")}:
                          </label>
                        </div>
                        <div className="col-sm-8">
                          <Input
                            type="text"
                            value={Money_provider}
                            name="Money_provider"
                            onChange={Search_Name_Handle}
                            onKeyUp={R_hanldeKeyup}
                            onKeyDown={R_hanldeKeydown}
                            className="form-control fk text-center"
                            autoComplete="off"
                            style={{
                              fontSize: "16px",
                              borderBottomColor: "#4064d7",
                            }}
                          />
                          {List_names.length !== 0 && (
                            <>
                              <ul
                                className="list-group"
                                style={{
                                  overflowY: "scroll",
                                  border: "1px solid white",
                                  height: "250px",
                                  scrollMarginBottom: "30px",
                                }}
                              >
                                {List_names &&
                                  List_names.map((item, idx) => (
                                    <li
                                      className={
                                        R_cursor === idx
                                          ? "active_search list-group-item"
                                          : "list-group-item"
                                      }
                                      key={idx}
                                      onClick={() =>
                                        this.setState({
                                          Money_provider: item.name,
                                          List_names: [],
                                        })
                                      }
                                    >
                                      {item.name}
                                    </li>
                                  ))}
                              </ul>
                            </>
                          )}
                          {is_validate === false || Money_provider ? null : (
                            <label
                              className="fk"
                              style={{
                                color: "red",
                                fontSize: "12px",
                                fontWeight: "bold",
                                marginLeft: "100px",
                              }}
                            >
                              {change_Lang("Please fill those cells")}
                            </label>
                          )}
                        </div>
                      </div>
                      <div className="product-price digits mt-2 form-group row ">
                        <div className="col-sm-4 ">
                          <label
                            style={{
                              fontSize: "18px",
                              color: "#4064d7",
                              fontWeight: "bold",
                            }}
                            className="d-flex justify-content-start  col-form-label fk"
                          >
                            {change_Lang("It was given to sir")}:
                          </label>
                        </div>
                        <div className="col-sm-8 ">
                          {box_status !== "off" ? (
                            <input
                              type="text"
                              className="form-control fk text-center"
                              value={`${user.fname} ${user.lname}`}
                              autoComplete="off"
                              style={{
                                fontSize: "17px",
                                borderBottomColor: "#4064d7",
                              }}
                            />
                          ) : (
                            <input
                              type="text"
                              className="form-control fk text-center"
                              value={Money_recive}
                              onChange={OnChangeHandler}
                              name="Money_recive"
                              autoComplete="off"
                              style={{
                                fontSize: "17px",
                                borderBottomColor: "#4064d7",
                              }}
                            />
                          )}
                        </div>
                      </div>
                      <div className="product-price digits mt-2 form-group row ">
                        <div className="col-sm-4 ">
                          <label
                            style={{
                              fontSize: "18px",
                              color: "#4064d7",
                              fontWeight: "bold",
                            }}
                            className="d-flex justify-content-start  col-form-label fk"
                          >
                            {change_Lang("Instead of")}:
                          </label>
                        </div>
                        {/* karwan */}
                        {this.state.type !== change_Lang("investor") ? (
                          <>
                            {this.state.type !==
                            change_Lang("Monthly rent invoice") ? (
                              <>
                                <div className="col-sm-4 ">
                                  <input
                                    type="text"
                                    className="form-control fk"
                                    value={this.state.type}
                                    autoComplete="off"
                                    style={{
                                      fontSize: "17px",
                                      borderBottomColor: "#4064d7",
                                    }}
                                  />
                                </div>
                                <div className="col-sm-4 ">
                                  <PropertyesList
                                    onChangeProperty={
                                      this.handleChange_Property
                                    }
                                    valueOption={property}
                                  />

                                  {is_validate === false || property ? null : (
                                    <label
                                      className="fk"
                                      style={{
                                        color: "red",
                                        fontSize: "12px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {change_Lang("Please fill those cells")}
                                    </label>
                                  )}
                                </div>
                                <br /> <br />
                                <div className="col-sm-4 ">
                                  <label
                                    style={{
                                      fontSize: "18px",
                                      color: "#4064d7",
                                      fontWeight: "bold",
                                    }}
                                    className="d-flex justify-content-start  col-form-label fk"
                                  >
                                    {change_Lang("first_rule_place")}:
                                  </label>
                                </div>
                                <div className="col-sm-4 ">
                                  <input
                                    type="text"
                                    className="form-control fk"
                                    value={place}
                                    name="place"
                                    onChange={OnChangeHandler}
                                    maxLength={180}
                                    autoComplete="off"
                                    style={{
                                      fontSize: "17px",
                                      borderBottomColor: "#4064d7",
                                    }}
                                  />
                                  {is_validate === false || place ? null : (
                                    <label
                                      className="fk"
                                      style={{
                                        color: "red",
                                        fontSize: "12px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {change_Lang("Please fill those cells")}
                                    </label>
                                  )}
                                </div>
                                <div className="col-sm-1 ">
                                  <label
                                    style={{
                                      fontSize: "18px",
                                      color: "#4064d7",
                                      fontWeight: "bold",
                                    }}
                                    className="d-flex justify-content-start  col-form-label fk"
                                  >
                                    {change_Lang("Number")}:
                                  </label>
                                </div>
                                <div className="col-sm-3 ">
                                  <input
                                    type="text"
                                    className="form-control fk"
                                    value={num}
                                    name="num"
                                    onChange={OnChangeHandler}
                                    maxLength={180}
                                    autoComplete="off"
                                    style={{
                                      fontSize: "17px",
                                      borderBottomColor: "#4064d7",
                                    }}
                                  />
                                  {is_validate === false || num ? null : (
                                    <label
                                      className="fk"
                                      style={{
                                        color: "red",
                                        fontSize: "8px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {change_Lang("Please fill those cells")}
                                    </label>
                                  )}
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="col-sm-4 ">
                                  <input
                                    type="text"
                                    className="form-control fk"
                                    value={this.state.type}
                                    autoComplete="off"
                                    style={{
                                      fontSize: "17px",
                                      borderBottomColor: "#4064d7",
                                    }}
                                  />
                                </div>
                                <div className="col-sm-4 ">
                                  <PropertyesList
                                    onChangeProperty={
                                      this.handleChange_Property
                                    }
                                    valueOption={property}
                                    size="large"
                                  />
                                  {is_validate === false || property ? null : (
                                    <label
                                      className="fk"
                                      style={{
                                        color: "red",
                                        fontSize: "12px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {change_Lang("Please fill those cells")}
                                    </label>
                                  )}
                                </div>
                                <br /> <br />
                                <div className="col-sm-4 ">
                                  <label
                                    style={{
                                      fontSize: "18px",
                                      color: "#4064d7",
                                      fontWeight: "bold",
                                    }}
                                    className="d-flex justify-content-start  col-form-label fk"
                                  >
                                    {change_Lang("first_rule_place")}:
                                  </label>
                                </div>
                                <div className="col-sm-4 ">
                                  <input
                                    type="text"
                                    className="form-control fk"
                                    value={place}
                                    name="place"
                                    onChange={OnChangeHandler}
                                    maxLength={180}
                                    autoComplete="off"
                                    style={{
                                      fontSize: "17px",
                                      borderBottomColor: "#4064d7",
                                    }}
                                  />
                                  {is_validate === false || place ? null : (
                                    <label
                                      className="fk"
                                      style={{
                                        color: "red",
                                        fontSize: "10px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {change_Lang("Please fill those cells")}
                                    </label>
                                  )}
                                </div>
                                <div className="col-sm-1 ">
                                  <label
                                    style={{
                                      fontSize: "18px",
                                      color: "#4064d7",
                                      fontWeight: "bold",
                                    }}
                                    className="d-flex justify-content-start  col-form-label fk"
                                  >
                                    {change_Lang("Number")}:
                                  </label>
                                </div>
                                <div className="col-sm-3 ">
                                  <input
                                    type="text"
                                    className="form-control fk"
                                    value={num}
                                    name="num"
                                    onChange={OnChangeHandler}
                                    maxLength={180}
                                    autoComplete="off"
                                    style={{
                                      fontSize: "17px",
                                      borderBottomColor: "#4064d7",
                                    }}
                                  />
                                  {is_validate === false || num ? null : (
                                    <label
                                      className="fk"
                                      style={{
                                        color: "red",
                                        fontSize: "8px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {change_Lang("Please fill those cells")}
                                    </label>
                                  )}
                                </div>
                                <br /> <br />
                                {/* felo */}
                                <div className="col-sm-4 ">
                                  <label
                                    style={{
                                      fontSize: "18px",
                                      color: "#4064d7",
                                      fontWeight: "bold",
                                    }}
                                    className="d-flex justify-content-start  col-form-label fk"
                                  >
                                    {change_Lang("On the date of")}:
                                  </label>
                                </div>
                                {/* karwan */}
                                <div className="col-sm-4 ">
                                  <input
                                    type="date"
                                    className="form-control fk"
                                    value={from}
                                    name="from"
                                    onChange={OnChangeHandler}
                                    maxLength={180}
                                    autoComplete="off"
                                    formAction="DD/MM/YYYY"
                                    style={{
                                      fontSize: "17px",
                                      borderBottomColor: "#4064d7",
                                    }}
                                  />
                                  {/* <DatePicker
                                    selected={from}
                                    onChange={(date) =>
                                      this.handleDateChange(date, "from")
                                    }
                                    dateFormat="dd/MM/yyyy"
                                    className=" text-center form-control "
                                    customInput={<CustomDatePickerInput />}
                                  /> */}
                                </div>
                                <div className="col-sm-4 ">
                                  <input
                                    type="date"
                                    className="form-control fk"
                                    value={to}
                                    name="to"
                                    onChange={OnChangeHandler}
                                    autoComplete="off"
                                    style={{
                                      fontSize: "17px",
                                      borderBottomColor: "#4064d7",
                                    }}
                                  />
                                  {/* <DatePicker
                                    selected={to}
                                    onChange={(date) =>
                                      this.handleDateChange(date, "to")
                                    }
                                    dateFormat="dd/MM/yyyy"
                                    className=" text-center"
                                    customInput={<CustomDatePickerInput />}
                                  /> */}
                                </div>
                              </>
                            )}
                          </>
                        ) : (
                          <div className="col-sm-8">
                            <input
                              type="text"
                              className="form-control fk"
                              value={instead_of}
                              name="instead_of"
                              onChange={OnChangeHandler}
                              autoComplete="off"
                              style={{
                                fontSize: "17px",
                                borderBottomColor: "#4064d7",
                              }}
                            />
                          </div>
                        )}
                      </div>
                      <br />
                    </div>
                    <div className="col-sm-6 ">
                      <div className="product-price digits mt-2 d-flex justify-content-start form-group row">
                        <div className="col-sm-4">
                          <label
                            style={{
                              fontSize: "18px",
                              color: "#4064d7",
                              fontWeight: "bold",
                            }}
                            className="d-flex justify-content-start  col-form-label fk"
                          >
                            {change_Lang("money")}:
                          </label>
                        </div>
                        <div className="col-sm-8">
                          <NumberFormat
                            displayType="input"
                            thousandSeparator={true}
                            name="Amount"
                            onChange={OnChangeHandler}
                            value={Amount === 0 ? "" : Amount}
                            required
                            className="form-control fk text-center"
                            autoComplete="off"
                            style={{
                              fontSize: "16px",
                              borderBottomColor: "#4064d7",
                            }}
                          />
                          {is_validate === false || Amount ? null : (
                            <label
                              className="fk"
                              style={{
                                color: "red",
                                fontSize: "12px",
                                fontWeight: "bold",
                                marginLeft: "100px",
                              }}
                            >
                              {change_Lang("Please fill those cells")}
                            </label>
                          )}
                        </div>
                      </div>
                      <div className="product-price digits form-group row">
                        <div className="col-sm-4">
                          <label
                            style={{
                              fontSize: "18px",
                              color: "#4064d7",
                              fontWeight: "bold",
                            }}
                            className="d-flex justify-content-start  col-form-label fk"
                          >
                            {change_Lang("Currency Type")}:
                          </label>
                        </div>
                        <div className="col-sm-8 d-flex justify-content-start text-right">
                          <Select
                            onChange={this.handleChange_Currency}
                            value={currency}
                            defaultValue={change_Lang("Choose")}
                            className="fk col-12 text-center"
                            showArrow={false}
                            size="large"
                            style={{
                              fontSize: "16px",
                              borderBottomColor: "#4064d7",
                            }}
                          >
                            <Option
                              className="fk"
                              style={{
                                fontWeight: "bold",
                                fontSize: "16px",
                              }}
                              value=""
                            >
                              {change_Lang("Choose")}
                            </Option>
                            <Option
                              value="dolar"
                              className="fk"
                              style={{
                                fontWeight: "bold",
                                fontSize: "16px",
                              }}
                            >
                              {change_Lang("dolar")}
                            </Option>
                            <Option
                              className="fk"
                              style={{
                                fontWeight: "bold",
                                fontSize: "16px",
                              }}
                              value="dinar"
                            >
                              {change_Lang("dinar")}
                            </Option>
                          </Select>
                        </div>
                      </div>
                      {is_validate === false || currency ? null : (
                        <label
                          className="fk"
                          style={{
                            color: "red",
                            fontSize: "12px",
                            fontWeight: "bold",
                            marginLeft: "100px",
                          }}
                        >
                          {change_Lang("Please fill those cells")}
                        </label>
                      )}
                      {/* ayat */}
                      <div className="product-price digits form-group row">
                        <div className="col-sm-4 d-flex justify-content-start">
                          <label
                            style={{
                              fontSize: "12px",
                              color: "#4064d7",
                              fontWeight: "bolder",
                            }}
                            className="d-flex justify-content-start  col-form-label fk"
                          >
                            {change_Lang("Does the money go into the box?")}:
                          </label>
                        </div>
                        <div className="col-sm-8 d-flex justify-content-start text-right">
                          <Select
                            onChange={this.handleChange_Box}
                            value={box_status}
                            defaultValue={change_Lang("Choose")}
                            className="fk col-12 text-center"
                            showArrow={false}
                            size="large"
                            style={{
                              fontSize: "16px",
                              borderBottomColor: "#4064d7",
                            }}
                          >
                            <Option value="" className="fk">
                              {change_Lang("Choose")}
                            </Option>
                            <Option className="fk" value={"on"}>
                              {change_Lang("Yes")}
                            </Option>
                            <Option className="fk" value={"off"}>
                              {change_Lang("No")}
                            </Option>
                          </Select>
                        </div>
                      </div>
                      {is_validate === false || box_status ? null : (
                        <label
                          className="fk"
                          style={{
                            color: "red",
                            fontSize: "12px",
                            fontWeight: "bold",
                            marginLeft: "100px",
                          }}
                        >
                          {change_Lang("Please fill those cells")}
                        </label>
                      )}
                      <div className="product-price digits mt-2 d-flex justify-content-start form-group row">
                        <div className="col-sm-4">
                          <label
                            style={{
                              fontSize: "18px",
                              color: "#4064d7",
                              fontWeight: "bold",
                            }}
                            className="d-flex justify-content-start  col-form-label fk"
                          >
                            {change_Lang("note")}:
                          </label>
                        </div>
                        <div className="col-sm-8">
                          <input
                            type="text"
                            className="form-control fk"
                            value={note}
                            name="note"
                            onChange={OnChangeHandler}
                            autoComplete="off"
                            style={{
                              fontSize: "16px",
                              borderBottomColor: "#4064d7",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {user && user.c_bill !== false ? (
                    <div className="py-3 px-5 d-flex justify-content-center">
                      <button
                        className="btn"
                        style={{ background: "#4350d8" }}
                        onClick={() => {
                          this.onCreating_Take_Money();
                        }}
                      >
                        <span
                          className="d-none d-lg-inline"
                          style={{ color: "white", fontSize: "12px" }}
                        >
                          {change_Lang("save")} &nbsp;
                        </span>

                        <FaRegSave
                          style={{ fontSize: "17px", color: "white" }}
                        />
                      </button>
                      <button
                        className="btn mx-5"
                        style={{ background: "#7F8C8D" }}
                        onClick={this.New_Page}
                      >
                        <span
                          className="d-none d-lg-inline"
                          style={{ color: "white", fontSize: "12px" }}
                        >
                          {change_Lang("new_page")} &nbsp;
                        </span>
                        <FaRegFile
                          style={{ fontSize: "17px", color: "white" }}
                        />
                      </button>
                      <button
                        className="btn"
                        style={{ background: "#4350d8" }}
                        onClick={() => {
                          onCreating_TakeMoney_Print();
                        }}
                      >
                        <span
                          className="d-none d-lg-inline"
                          style={{ color: "white", fontSize: "12px" }}
                        >
                          {change_Lang("Print")} &nbsp;
                        </span>
                        <FaPrint style={{ fontSize: "17px", color: "white" }} />
                      </button>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </Tabs>
        </Fragment>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.HelperReducer.lang,
    user: state.AuthReducer.user,
    name_krd: state.HelperReducer.name_krd,
    name_arb: state.HelperReducer.name_arb,
    name_en: state.HelperReducer.name_en,
    sell_invoice_obj: state.Invoice_Reducer.sell_invoice_obj,
    rent_invoice_obj: state.Invoice_Reducer.rent_invoice_obj,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    change_Lang: (key) => dispatch(change_Lang(key)),
    EveryTimeTo_English: (keys) => dispatch(EveryTimeTo_English(keys)),
    Creating_Take_Money: (id, data) => dispatch(Creating_Take_Money(id, data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TakeMoney);
